

  
const content = `# User Management
  
After an organization account is created, the user with the System Administrator role can invite other users from the same organization to join the newly created 
organization account. Please note that the OnData Platform supports Single Sign-On (SSO) integration with customer's existing Identity and Access Management (IAM) 
system. If you plan to enable SSO integration, you **do not** need to follow any of the steps below to manage your users. Instead, please follow the instructions in 
[**Single Sign-On Integration**](reference_doc#ondata_portal/sso_integration/overview) on how to manage users and their roles for the OnData Platform from your IAM system.  

First, please follow the steps below to go to the user management page at the OnData Portal:  
a. Login as a System Administrator to the OnData Portal  
b. Select \`Settings\` -> \`Organization\` -> \`Users\`, or go to the user management page directly at https://us.ondatahub.com/settings/organization/user-manage  
  
Once you are at the user management page, you can access any of the following user management functions.  
  
## Invite New Users
a. Click on the \`Invite New User\` button and enter a new user's email. Please note that the email domain must be the same as the System Administrator's email domain. 
If you would like to invite multiple users, their email addresses can be separated by \`";"\`  
b. Select one or more OnData Application Role(s) for the new user(s) to be added. You may refer to the [**OnData Application Roles**](reference_doc#ondata_portal/ondata_application_roles) page 
for more details. Please note that the \`SecureFileOnly\` role should not be combined with any other roles in your selection  
c. Click on the \`Send Invitation\` button to invite the new user(s). The invited user(s) will receive an email and can click on the link inside to join your 
organization account  
  
## Edit Existing Users
a. Search and find an existing user, and click on the \`Edit\` button to edit the user's OnData Application Role(s) and Data Access Roles. You may refer to the 
[**OnData Application Roles**](reference_doc#ondata_portal/ondata_application_roles) page and the [**Data Access Roles**](reference_doc#ondata_portal/data_access_roles) page for more details. Please note that the 
\`SecureFileOnly\` role should not be combined with any other roles in your selection  
b. Click on the \`Update\` button to save the changes  
  
## Delete Existing Users
a. Search and find an existing user, and click on the \`Delete\` button to delete the user's account from your organization  
b. Choose the \`Confirm\` button to confirm the deletion    
  
  
`
  
export default content;
